import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { DeliveryAddress, ICheckout, IFranchsiePosalCode, ResponseClass } from '../../shared/Interfaces/ILogin';
import { MatSnackBar, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { DataService } from '../../shared/data.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { debounceTime, finalize } from 'rxjs/operators';
import { HelperService } from 'src/app/shared/Helper.service';

@Component({
  selector: 'app-select-delivery-address-dialog',
  templateUrl: './select-delivery-address-dialog.component.html',
  styleUrls: ['./select-delivery-address-dialog.component.css'], encapsulation: ViewEncapsulation.None 
})
export class SelectDeliveryAddressDialogComponent implements OnInit {

  deliveryInfo = new FormGroup({
    deliveryAddress: new FormControl(''),
    postalCode: new FormControl(''),
    siteContact: new FormControl(''),
    notes: new FormControl(''),
    unitNo: new FormControl('')
  });

  allAddresses: DeliveryAddress[] = [];
  checkout: ICheckout;
  customerId: number;
  franchiseId: number;
  public isPageReload: string;
  
  notes: string = "";
  isVerifyingPostalCode: boolean = false;

  currentAddress: number;
  constructor(private _snackBar: MatSnackBar, public fb: FormBuilder, private dataService: DataService,
    private ngxUiLoaderService: NgxUiLoaderService, private helperService: HelperService,
    private dialogRef: MatDialogRef<SelectDeliveryAddressDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data) {
    this.customerId = data.customerId;
    this.franchiseId = data.franchiseId;
    this.currentAddress = data.addressId;
  }

  ngOnInit() {
    this.getDeliveryAddress();
    this.isPageReload =localStorage.getItem('order_deliveryAddress');

    if (this.deliveryInfo.valid) {
      this.updateAddress();
    }

    this.deliveryInfo.valueChanges.pipe(
      debounceTime(5000)
    ).subscribe((value) => {
      //if (this.deliveryInfo.valid) {

      this.updateAddress();

      //}
    });
  }

  getDeliveryAddress() {
    this.dataService.getCustomerDeliveryAddressList(this.customerId, this.franchiseId)
      .subscribe(
        (data: DeliveryAddress[]) => {
          this.allAddresses = data;
        },
        (err: any) => console.log(err),
        () => {
          console.log("units Data Recived");
        }
      );
  }

  updateAddress(): void {

    if (this.notes != null && this.notes != undefined) {
      this.dataService.updateNotesAddress(this.notes, this.customerId)
        .subscribe(
          (data: IFranchsiePosalCode) => {
          },
          (err: any) => {
          },
          () => {
            console.log("delivery options selected");
          }
        );
    }

  }

  saveChanges(address: DeliveryAddress): void {
    console.log('saveChanges called for address:', address.addressId, 'with postal code:', address.postalCodeZip);
    // First verify the postal code before selecting the address
    this.verifyPostalCodeAndSelectAddress(address);
  }

  verifyPostalCodeAndSelectAddress(address: DeliveryAddress): void {
    console.log('Starting postal code verification for:', address.postalCodeZip);
    this.isVerifyingPostalCode = true;
    this.ngxUiLoaderService.start();
    
    // Add a timeout to handle cases where the request might hang
    const timeoutId = setTimeout(() => {
      console.log('Postal code verification timeout');
      this.isVerifyingPostalCode = false;
      this.ngxUiLoaderService.stop();
      let message = "Error verifying postal code. Please try again or select a different address.";
      let action = "Ok";
      this._snackBar.open(message, action, {
        duration: 10000,
        horizontalPosition: "center",
        verticalPosition: "bottom",
        panelClass: ['error-snackbar']
      });
    }, 10000); // 10 second timeout
    
    // Verify the postal code using the data service
    this.dataService.verifyPostalCode(address.postalCodeZip)
      .pipe(finalize(() => {
        clearTimeout(timeoutId);
        this.isVerifyingPostalCode = false;
        this.ngxUiLoaderService.stop();
      }))
      .subscribe(
        (data: IFranchsiePosalCode) => {
          console.log('Postal code verification response:', data);
          
          // If we get a valid response with franchise data, the postal code is valid
          if (data && data.franchiseId) {
            console.log('Postal code is valid, proceeding with address selection');
            this.selectDeliveryAddress(address);
          } else {
            console.log('Postal code verification failed - no franchise data');
            // Postal code is invalid, show error message
            let message = "We do not serve in this postal code. Please select a different address.";
            let action = "Ok";
            this._snackBar.open(message, action, {
              duration: 10000,
              horizontalPosition: "center",
              verticalPosition: "bottom",
              panelClass: ['error-snackbar']
            });
          }
        },
        (err: any) => {
          console.log('Postal code verification error:', err);
          console.log('Error status:', err.status);
          console.log('Error message:', err.message);
          
          // Handle 404 error specifically (postal code not found)
          if (err.status === 404) {
            console.log('404 error - postal code not found');
            let message = "We do not serve in this postal code. Please select a different address.";
            let action = "Ok";
            this._snackBar.open(message, action, {
              duration: 10000,
              horizontalPosition: "center",
              verticalPosition: "bottom",
              panelClass: ['error-snackbar']
            });
          } else {
            console.log('Other error during postal code verification');
            // Handle other errors
            let message = "Error verifying postal code. Please try again or select a different address.";
            let action = "Ok";
            this._snackBar.open(message, action, {
              duration: 10000,
              horizontalPosition: "center",
              verticalPosition: "bottom",
              panelClass: ['error-snackbar']
            });
          }
        }
      );
  }

  selectDeliveryAddress(address: DeliveryAddress): void {
    console.log('Selecting delivery address:', address.addressId);
    this.dataService.selectDeliveryAddress(address.addressId, this.customerId).subscribe(
      (data: ResponseClass) => {
        console.log('Address selection response:', data);
        localStorage.setItem('order_deliveryAddress', 'true');
        this.ngxUiLoaderService.start();
        this.dataService.getCheckout(this.customerId)
        .subscribe(
          (checkoutData: ICheckout) => {
            this.ngxUiLoaderService.stop();
            if (checkoutData != null) {
              this.checkout = checkoutData;
              this.updateAddress();
              this.helperService.checkoutDetails=this.checkout;
              this.helperService.changecheckoutValue.next();
              localStorage.setItem('checkout', JSON.stringify(this.checkout));
              localStorage.setItem('deliveryAddress_status', 'false');
              localStorage.setItem('order_deliveryAddress', 'true');
            }}
            );
        
        this.dialogRef.close();
      },
      (err: any) => console.log(err)
    );
  }

}
